// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { rootstockTestnet as _rootstockTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the rootstockTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 31
 * Chain Name: Rootstock Testnet
 * Default Block Explorer: https://explorer.testnet.rootstock.io
 * Default RPC URL: https://public-node.testnet.rsk.co
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { rootstockTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: rootstockTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const rootstockTestnet = createCommon({
	..._rootstockTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
